

<div class="banner-carousel" (mouseover)="onMouseOver()" (mouseout)="onMouseOut()">
	@for (slide of slides; track slide._id; let index = $index) {
		<div class="_slide" [class.active]="index == slideIndex()" [class.with-action]="slide.hasClickAction" (click)="slideClick(slide)">
			<img [appImageSrc]="slide.parsedUrl" [model]="slide" loading="lazy" alt="{{slide.name}}"/>
		</div>
	}
	@if (slides.length > 1) {
		<div class="_slide-arrows">
			<div (click)="moveSlide(-1)">
				<mat-icon class="rotate-rtl">chevron_left</mat-icon>
			</div>
			<div  (click)="moveSlide(1)">
				<mat-icon class="rotate-rtl">chevron_right</mat-icon>
			</div>
		</div>
		<div class="_slide-bullets">
			@for (slide of slides; track slide._id; let index = $index) {
				<div class="_slide-bullet" [class.active]="index == slideIndex()" (click)="setSlide(index)"></div>
			}
		</div>
	}
</div>

